document.documentElement.className = document.documentElement.className.replace('no-js', 'js');

window.videowiseShadow = { 
  mode: 'closed', 
  assets: [{ 
    type: 'style', 
    src: '{{ "custom-videowise.css" | asset_url }}'
  }] 
};

document.addEventListener("DOMContentLoaded", function () {
  const labelElement = document.querySelector('label.rc-radio.subscription-radio[for="rc-radio2"]');

  if (labelElement) {
    const badgeSpan = document.createElement("span");
    badgeSpan.className = "subscription-best-badge";
    badgeSpan.textContent = "Best Value";
    labelElement.appendChild(badgeSpan);
    console.log("Span added successfully:", badgeSpan);
  } else {
    console.error("Label element with for='rc-radio2' not found.");
  }
});

document.addEventListener("DOMContentLoaded", function () {
  function removeWebPixelContainer() {
    var webPixelContainer = document.querySelector("#web-pixels-manager-sandbox-container");
    if (webPixelContainer) {
      webPixelContainer.remove();
      console.log("Web Pixels container removed.");
    }
  }

  removeWebPixelContainer();

  const observer = new MutationObserver(() => {
    removeWebPixelContainer();
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

function replaceRechargeWithDropdown() {
  const container = document.querySelector('.rc-template__radio');
  if (!container) return;

  const radios = container.querySelectorAll('label.rc-radio');
  if (radios.length === 0) return;

  radios.forEach(label => label.style.display = 'none');

  const wrapper = document.createElement('div');
  wrapper.className = 'rc-custom-wrapper';

  const label = document.createElement('label');
  label.className = 'rc-custom-label';
  label.textContent = 'Subscribe & Save 10% : Optional';

  const select = document.createElement('select');
  select.className = 'rc-custom-select';

  radios.forEach((radio) => {
    const input = radio.querySelector('input[type="radio"]');
    const span = radio.querySelector('.rc-radio__label');

    const option = document.createElement('option');
    option.value = input.value;
    option.textContent = span?.textContent?.trim();
    if (input.checked) option.selected = true;

    select.appendChild(option);
  });

  select.addEventListener('change', (e) => {
    const selectedValue = e.target.value;
    const inputs = container.querySelectorAll('input[type="radio"]');

    inputs.forEach((input) => {
      if (input.value === selectedValue) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });

  wrapper.appendChild(label);
  wrapper.appendChild(select);
  container.appendChild(wrapper);
}

function waitForRechargeWidget(retries = 20) {
  if (document.querySelector('.rc-template__radio')) {
    replaceRechargeWithDropdown();
  } else if (retries > 0) {
    setTimeout(() => waitForRechargeWidget(retries - 1), 500);
  }
}

waitForRechargeWidget();

document.addEventListener('DOMContentLoaded', function() {
  let lastScroll = window.pageYOffset || document.documentElement.scrollTop;
  const scrollThreshold = 50;

  window.addEventListener('scroll', () => {
    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

    if (Math.abs(currentScroll - lastScroll) < 10) return;

    if (currentScroll > lastScroll && currentScroll > scrollThreshold) {
      document.body.classList.remove('sticky-header');
    } else if (currentScroll < lastScroll) {
      document.body.classList.add('sticky-header');
    }

    lastScroll = currentScroll <= 0 ? 0 : currentScroll;
  }, { passive: true });
});

document.addEventListener('DOMContentLoaded', function() {
  function isIE() {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf('MSIE ');
    const trident = ua.indexOf('Trident/');
    return(msie > 0 || trident > 0);
  }
  if (! isIE()) 
    return;
  
  const hiddenInput = document.querySelector('input[name="id"]');
  const noScriptInputWrapper = document.createElement('div');
  const variantSwitcher = document.querySelector('variant-radios') || document.querySelector('variant-selects');
  if (variantSwitcher) {
    noScriptInputWrapper.innerHTML = document.querySelector('.product-form__noscript-wrapper').textContent;
    variantSwitcher.outerHTML = noScriptInputWrapper.outerHTML;
    document.querySelector('#Variants').addEventListener('change', function(event) {
      hiddenInput.value = event.currentTarget.value;
    });
  }
});

